module.exports = __webpack_public_path__ + "img/[流汗].47261213.svg";